import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

export default function ProtectedRoute({ allowed, children }) {
  const { user } = useSelector((state) => state.auth)

  if (!allowed.includes(user?.id)) {
    return <Navigate to='/unauthorized' replace />
  }
  return children
}
